export default __webpack_public_path__ + "static/media/stamp-logo.711eb5a6.svg";